import gql from 'graphql-tag';

export const gqlGetPendingReceptionQuery = gql`
  query getIdocs($limit: Int, $offset: Int, $order: String, $where: String) {
    getIdocs(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        identificationDocument
        dateCollected
        collectionPointName
        colpointAddressLine1
        materialId
        material {
          id
          name
        }
        netWeight
        receptionNetWeight
        collectorCompanyName
        vehPlateNumber
        driverFullName
        wastereceptionpointCompanyName
        dateStorage
      }
      recordCount
    }
  }
`;

export { gqlUpdate } from '../idocs/graphql';
